import React from 'react';
import { motion } from 'framer-motion';
const SHOPIFY_URL = 'https://elevaemily.com/products/controla-la-ansiedad-1?variant=53010420498795';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  size?: 'md' | 'lg';
}
export function CTAButton({
  children,
  href = SHOPIFY_URL,
  onClick,
  className = '',
  size = 'lg'
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-full text-white bg-terracotta hover:bg-terracotta-dark transition-colors shadow-lg shadow-terracotta/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta focus:ring-offset-cream';
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-lg' : 'px-6 py-3 text-base';
  const Element = motion.a;
  const handleClick = (e: React.MouseEvent) => {
    // Fire AddToCart when clicking a button that goes to Shopify
    if (href === SHOPIFY_URL) {
      const fbq = (window as any).fbq;
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_name: 'Controla la Ansiedad - Sistema Completo',
          content_type: 'product',
          value: 17,
          currency: 'USD'
        });
      }
    }
    if (onClick) {
      onClick();
    }
  };
  return <Element href={href} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} data-id="element-27">
      {children}
    </Element>;
}